const CONTEST_STORE_KEY = "ykmk_contest_applications";
const REVIEW_STORE_KEY = "ykmk_contest_reviews";

const CONTEST_MAP = {
  "graduation-art": {
    id: "graduation-art",
    name: "全国毕业季工艺美术类优秀毕业作品大赛",
    logo: "艺科美课",
    hero: "面向全国院校工艺美术专业毕业生，汇聚创意工美与科技工美优秀作品。",
    deadline: "2026-05-30T23:59:59+08:00",
    sections: {
      detail:
        "作品要求原创，内容健康向上，突出原创性、创新性、艺术性和当代价值，支持独立与团队报名。",
      process: [
        "报名阶段：提交作者与作品资料",
        "资格审查：组委会核验报名信息",
        "评审阶段：专家评审 / 大众喜爱评审",
      ],
      tracks: [
        "创意工美",
        "科技工美",
        "陶瓷艺术",
        "文创设计",
        "玻璃艺术",
        "纤维艺术",
        "金属艺术",
        "雕刻艺术",
        "首饰艺术",
      ],
    },
  },
  "cashmere-design": {
    id: "cashmere-design",
    name: "Young·绒—2026第二届中国创新创意设计大赛",
    logo: "艺科美课",
    hero: "聚焦羊绒主题创意设计，面向家具文创、服装设计、公共艺术等方向征集作品。",
    deadline: "2026-06-20T23:59:59+08:00",
    sections: {
      detail:
        "参赛作品需围绕羊绒材料与工艺创新，支持实物与设计稿两种展现形式，报名后可进入评审流程。",
      process: ["报名阶段", "资格审查", "终评与公布"],
      tracks: ["家具及文创", "服装设计", "公共艺术", "设计稿", "实物作品"],
    },
  },
};

const DEFAULT_WORKS = {
  "graduation-art": [
    {
      id: "g-001",
      image:
        "https://images.unsplash.com/photo-1513351105277-204e8c0f9b64?auto=format&fit=crop&w=1200&q=80",
      workName: "流光釉影",
      intro: "以陶瓷与金属结合探索新工艺表现。",
      material: "陶瓷 / 金属",
      size: "120 x 60 x 60 cm",
      weightKg: 28,
      track: "陶瓷艺术",
    },
    {
      id: "g-002",
      image:
        "https://images.unsplash.com/photo-1452802447250-470a88ac82bc?auto=format&fit=crop&w=1200&q=80",
      workName: "织域",
      intro: "纤维材料的空间叙事与交互设计。",
      material: "纤维 / 木材",
      size: "200 x 100 x 50 cm",
      weightKg: 16,
      track: "纤维艺术",
    },
  ],
  "cashmere-design": [
    {
      id: "c-001",
      image:
        "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80",
      workName: "暖域",
      intro: "羊绒面料在服装结构上的再设计。",
      material: "羊绒 / 复合面料",
      size: "180 x 80 x 40 cm",
      weightKg: 9,
      track: "服装设计",
    },
    {
      id: "c-002",
      image:
        "https://images.unsplash.com/photo-1488901512917-408c21b9bb7d?auto=format&fit=crop&w=1200&q=80",
      workName: "轻城",
      intro: "羊绒文创家具与公共空间结合方案。",
      material: "羊绒 / 木材",
      size: "220 x 120 x 80 cm",
      weightKg: 42,
      track: "家具及文创",
    },
  ],
};

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function readStore(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    return fallback;
  }
}

function writeStore(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function nowText() {
  return new Date().toISOString().slice(0, 19).replace("T", " ");
}

function getCountdownDays(deadline) {
  const diff = new Date(deadline).getTime() - Date.now();
  if (diff <= 0) return 0;
  return Math.ceil(diff / (24 * 60 * 60 * 1000));
}

function getApplications() {
  return readStore(CONTEST_STORE_KEY, []);
}

function setApplications(list) {
  writeStore(CONTEST_STORE_KEY, list);
}

function getReviews() {
  return readStore(REVIEW_STORE_KEY, []);
}

function setReviews(list) {
  writeStore(REVIEW_STORE_KEY, list);
}

export function getContestDetail(contestId) {
  const target = CONTEST_MAP[contestId] || CONTEST_MAP["graduation-art"];
  return {
    ...clone(target),
    countdownDays: getCountdownDays(target.deadline),
  };
}

export function getContestList() {
  return Object.keys(CONTEST_MAP).map((id) => getContestDetail(id));
}

export function getContestWorks(contestId) {
  const staticWorks = clone(DEFAULT_WORKS[contestId] || []);
  const dynamicWorks = getApplications()
    .filter((item) => item.contestId === contestId)
    .map((item) => ({
      id: item.id,
      image: item.work.coverImage || "https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/pic/logo.png",
      workName: item.work.workName || "报名作品",
      intro: item.work.intro || "报名作品",
      material: item.work.material || "未填写",
      size: item.work.sizeSummary || "未填写",
      weightKg: item.work.weightKg || 0,
      track: item.work.track || "未分类",
    }));
  return staticWorks.concat(dynamicWorks);
}

export function submitContestApplication(contestId, userInfo, payload) {
  const list = getApplications();
  const duplicate = list.find(
    (item) => item.contestId === contestId && item.author && item.author.idNo === payload.author.idNo
  );
  if (duplicate) {
    throw new Error("同一作者在本赛事仅可报名一次");
  }

  const contest = getContestDetail(contestId);
  const id = `app_${Date.now()}`;
  const record = {
    id,
    uid: userInfo && userInfo.uid ? userInfo.uid : 0,
    contestId,
    contestName: contest.name,
    status: "报名中",
    actionText: "立即编辑",
    createTime: nowText(),
    author: clone(payload.author),
    work: clone(payload.work),
    payload: clone(payload),
  };
  list.unshift(record);
  setApplications(list);
  return { message: "报名提交成功", applicationId: id };
}

export function getMyContestEvents(uid) {
  if (!uid) return [];
  return getApplications()
    .filter((item) => Number(item.uid) === Number(uid))
    .map((item) => ({
      id: item.id,
      contestName: item.contestName,
      workName: item.work.workName || "未命名作品",
      status: item.status,
      actionText: item.actionText,
      createTime: item.createTime,
    }));
}

export function getMyReviewDrafts(uid, contestId, mode) {
  if (!uid) return [];
  return getReviews().filter(
    (item) =>
      Number(item.uid) === Number(uid) &&
      item.contestId === contestId &&
      item.mode === mode
  );
}

export function saveReviewAction(uid, contestId, mode, workId, action, score) {
  if (!uid) throw new Error("未登录");
  const list = getReviews();
  const now = nowText();
  const hit = list.find(
    (item) =>
      Number(item.uid) === Number(uid) &&
      item.contestId === contestId &&
      item.mode === mode &&
      item.workId === workId
  );
  if (hit) {
    hit.action = action;
    hit.score = action === "score" ? Number(score || 0) : 0;
    hit.submitted = false;
    hit.updateTime = now;
  } else {
    list.unshift({
      id: `rev_${Date.now()}_${workId}`,
      uid: Number(uid),
      contestId,
      mode,
      workId,
      action,
      score: action === "score" ? Number(score || 0) : 0,
      submitted: false,
      updateTime: now,
    });
  }
  setReviews(list);
  return true;
}

export function submitReviewDrafts(uid, contestId, mode) {
  if (!uid) throw new Error("未登录");
  const list = getReviews();
  const target = list.filter(
    (item) =>
      Number(item.uid) === Number(uid) &&
      item.contestId === contestId &&
      item.mode === mode
  );
  target.forEach((item) => {
    item.submitted = true;
    item.updateTime = nowText();
  });
  setReviews(list);
  return { count: target.length, message: "评审结果已提交" };
}

